import type { Concern, ConcernId, Product, Routine } from '../../core/types/catalog'
import type { QuizQuestion } from '../../data/quiz'
import { isSoldOut } from '../../core/rules/stock'

/** Zo lang duurt het sluiten van de lade; pas daarna wordt de quiz leeggemaakt. */
export const DRAWER_EXIT_MS = 300

/** De stap waarmee "klein beginnen" start: het werkzame product uit het protocol. */
export const STARTER_STEP = 'Behandelen'

type Lookup = {
  routines: Routine[]
  routineById: (id: string) => Routine | undefined
  concernById: (id: ConcernId) => Concern | undefined
}

/**
 * Het protocol bij de antwoorden. Elk antwoord telt mee voor het protocol van zijn klacht
 * (of een direct gekozen protocol), met zijn gewicht. Het hoogste totaal wint; zonder
 * uitslag het eerste protocol. Puur, zonder React.
 */
export function pickRoutine(questions: readonly QuizQuestion[], answers: readonly string[], { routines, routineById, concernById }: Lookup): Routine | undefined {
  const tally = new Map<string, number>()
  answers.forEach((answer, i) => {
    const option = questions[i]?.options.find((o) => o.label === answer)
    const concern = option?.concern ? concernById(option.concern) : undefined
    const routineId = option?.routineId ?? concern?.routineId
    if (!option || !routineId) return
    tally.set(routineId, (tally.get(routineId) ?? 0) + (option.weight ?? 1))
  })
  const winner = [...tally.entries()].sort((a, b) => b[1] - a[1])[0]?.[0]
  return (winner ? routineById(winner) : undefined) ?? routines[0]
}

/** Het belangrijkste product uit het protocol, voor wie klein wil starten. */
export function starterProduct(items: readonly Product[]): Product | undefined {
  // Uitverkocht is geen start; en bij één product is "klein beginnen" hetzelfde als het protocol.
  const available = items.filter((p) => !isSoldOut(p))
  if (items.length <= 1) return undefined
  return available.find((p) => p.step === STARTER_STEP) ?? available[0]
}

/** De antwoorden zoals de server ze wil: per vraag-id. */
export function answersForLead(questions: readonly QuizQuestion[], answers: readonly string[]) {
  return answers.flatMap((answer, i) => {
    const question = questions[i]
    return question ? [{ questionId: question.id, answer }] : []
  })
}
